import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Home, Sparkles } from 'lucide-react';
const benefits = [{
  icon: Heart,
  title: 'Aprendé sin experiencia',
  desc: 'Todo está explicado desde cero para que puedas avanzar paso a paso, aunque nunca hayas hecho flores de chenille.'
}, {
  icon: Sparkles,
  title: 'Creá productos con valor',
  desc: 'Hacé flores, ramos, cuadros, llaveros, souvenirs y diseños personalizados listos para regalar o vender.'
}, {
  icon: Home,
  title: 'Generá ingresos extra',
  desc: 'Una técnica simple y accesible que podés convertir en productos artesanales para ofrecer por Instagram, WhatsApp, ferias o fechas especiales.'
}];
export function Benefits() {
  return <section className="py-8 sm:py-10 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-27">
      <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10 px-2" data-id="element-28">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-4 sm:mb-6 font-bold leading-tight" data-id="element-29">
          ¿Te gustaría crear algo lindo con tus manos y que además pueda
          convertirse en un ingreso extra?
        </h2>
        
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto" data-id="element-30">
        {benefits.map((benefit, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="bg-deco-card rounded-[2rem] p-8 sm:p-10 shadow-sm border border-deco-warm hover:shadow-md transition-shadow flex flex-col items-center text-center relative overflow-hidden" data-id="element-31">
            <div className="absolute top-0 right-0 w-32 h-32 bg-deco-bg rounded-bl-full -z-10 opacity-50" data-id="element-32"></div>

            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-deco-warm flex items-center justify-center mb-6 text-deco-terra border border-deco-warm" data-id="element-33">
              <benefit.icon size={28} className="sm:w-8 sm:h-8" strokeWidth={1.5} data-id="element-34" />
            </div>
            <h3 className="text-xl sm:text-2xl mb-3 sm:mb-4 text-deco-text font-serif font-bold leading-tight" data-id="element-35">
              {benefit.title}
            </h3>
            <p className="text-deco-text/70 leading-relaxed font-normal text-sm sm:text-base" data-id="element-36">
              {benefit.desc}
            </p>
          </motion.div>)}
      </div>
    </section>;
}